module.exports = {
  white: '#fff',
  grey50: '#fafafa',
  grey100: '#f5f5f5',
  grey200: '#eeeeee',
  grey300: '#e0e0e0',
  grey400: '#bdbdbd',
  grey500: '#9e9e9e',
  grey600: '#757575',
  grey700: '#616161',
  grey800: '#424242',
  grey900: '#212121',
  brandPrimary: '#2cb7c6',
  brandYellow: '#ffaf3a',
  brandRed: '#db4c60',
  brandGreen: '#48b762',
  brandBlue: '#42a5f5',
  brandOrange: '#ff6d2f',
  lightBrandPrimary: '#e7f2f4',
  lightBrandYellow: '#ffe7c4',
  lightBrandRed: '#eda5af',
  lightBrandGreen: '#abdeb7',
  lightBrandBlue: '#bbdffb',
  lightBrandOrange: '#ffb89a',
  backgroundAlt: '#fafafa',
  facebookColor: '#275a9b',
  twitterColor: '#00a2f5',
  mailColor: '#3e8ee7',
  linkedinColor: '#0077b5',
  lighterOverlay: 'rgba(33, 33, 33, 0.05)',
  lightOverlay: 'rgba(33, 33, 33, 0.1)',
  baseBorderRadius: '3px',
  baseBorderRadiusBig: '4.5px',
  baseFontSize: '15px',
  baseFontFamily: '"Open Sans", sans-serif',
  baseFontFamilyAlt: '"brandon-grotesque", sans-serif',
  baseLineHeight: '1.5',
  textPrimaryDark: '#616161',
  textSecondaryDark: 'rgba(97, 97, 97, 0.7)',
  textTertiaryDark: 'rgba(97, 97, 97, 0.5)',
  textDisabledDark: 'rgba(97, 97, 97, 0.35)',
  textPrimaryWhite: '#fff',
  shadowPenumbraColor: 'rgba(0, 0, 0, 0.14)',
  shadowUmbraColor: 'rgba(0, 0, 0, 0.2)',
  shadowAmbientColor: 'rgba(0, 0, 0, 0.12)',
  elevationMinus2: '0 2px 2px 0 rgba(0, 0, 0, 0.14) inset, 0 3px 1px -2px rgba(0, 0, 0, 0.2) inset, 0 1px 5px 0 rgba(0, 0, 0, 0.12) inset',
  elevationMinus1: '0 1px 2px rgba(0, 0, 0, 0.14) inset, 0 2px 3px -2px rgba(0, 0, 0, 0.2) inset, 0 0 5px 0 rgba(0, 0, 0, 0.12) inset',
  elevation0: 'none',
  elevation1: '0 1px 2px rgba(0, 0, 0, 0.14), 0 2px 3px -2px rgba(0, 0, 0, 0.2), 0 0 5px 0 rgba(0, 0, 0, 0.12)',
  elevation2: '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
  elevation3: '0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.2), 0 1px 8px 0 rgba(0, 0, 0, 0.12)',
  elevation4: '0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.12)',
  elevation5: '0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12)',
  elevation6: '0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 3px 14px 2px rgba(0, 0, 0, 0.12)',
  elevation7: '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0  8px 10px -5px rgba(0, 0, 0, 0.2), 0  6px 30px 5px rgba(0, 0, 0, 0.12)',
  elevation8: '0  9px 46px  8px rgba(0, 0, 0, 0.14), 0 24px 38px  3px rgba(0, 0, 0, 0.2), 0 11px 15px -7px rgba(0, 0, 0, 0.12)',
  basePadding: '30px',
  basePaddingSmall: '15px',
  baseMargin: '30px',
  baseMarginSmall: '15px',
  baseTransitionTime: '0.3s',
  baseTransitionTimeShort: '0.15s',
  bouncyTransitionCurve: 'cubic-bezier(0.44, 0.11, 0.07, 1.29)',
  maxWidth: '1200px',
  screenXs: 'only screen and (max-width: 320px)',
  screenS: 'only screen and (max-width: 375px)',
  screenM: 'only screen and (max-width: 425px)',
  screenL: 'only screen and (max-width: 768px)',
  screenXl: 'only screen and (max-width: 1024px)',
  phoneS: 'only screen and (max-width: 320px)',
  phone: 'only screen and (max-width: 375px)',
  phoneXl: 'only screen and (max-width: 425px)',
  ipad: 'only screen and (max-width: 768px)',
  desktopS: 'only screen and (max-width: 1024px)',
  phoneSLandscape: 'only screen and (max-width: 768px)',
  phoneLandscape: 'only screen and (max-width: 768px)',
  phoneXlLandscape: 'only screen and (max-width: 768px)',
  ipadLandscape: 'only screen and (max-width: 1024px)',
  screenSOrM: '(max-width: 480px), (max-width: 768px)',
  greaterThanMaximumWidth: 'only screen and (min-width: 1200px)',
  greaterThanMinimumWidth: 'only screen and (min-width: 1024px)',
  screenXs_legacy: 'only screen and (max-width: 320px)',
  screenS_legacy: 'only screen and (max-width: 480px)',
  screenM_legacy: 'only screen and (max-width: 768px)',
  screenL_legacy: 'only screen and (max-width: 992px)',
  screenXl_legacy: 'only screen and (max-width: 1200px)',
  screenSOrM_legacy: '(max-width: 480px), (max-width: 768px)',
  greaterThanMaximumWidth_legacy: 'only screen and (min-width: 1200px)',
  greaterThanMinimumWidth_legacy: 'only screen and (min-width: 1000px)',
};

const tc = require('tinycolor2');


module.exports.lighten = function lighten(color, amount) {
  return tc(color).lighten(amount).toString();
}


module.exports.fade = function fade(color, amount) {
  return tc(color).setAlpha(amount / 100).toString();
}


module.exports.darken = function darken(color, amount) {
  return tc(color).darken(amount).toString();
}
